import { jsx as _jsx } from "react/jsx-runtime";
import toast from "react-hot-toast";
import { hasError } from "../utils/utils";
import ModerationToast from "../components/toast/ModerationToast";
export const useToastWrapper = ({ successMessage = "Success!", errorMessage = "An error occurred", successStyles = {
    background: "#00802F",
    color: "#ffffff",
}, errorStyles = {
    background: "#DB0000",
    color: "#ffffff",
}, succesIconTheme = {
    primary: "#ffffff",
    secondary: "#00802F",
}, errorIconTheme = {
    primary: "#ffffff",
    secondary: "#DB0000",
}, duration = {
    success: 3000,
    error: 4000,
}, position = "bottom-center", } = {}) => {
    const showSuccessToast = (message) => {
        toast.success(message || successMessage, {
            duration: duration.success,
            position,
            style: successStyles,
            iconTheme: succesIconTheme,
        });
    };
    const showErrorToast = (error) => {
        if (error &&
            hasError(error, "BIO_MODERATION")) {
            toast.error((t) => _jsx(ModerationToast, { onDismiss: () => toast.dismiss(t.id) }), {
                duration: duration.error,
                position,
                style: errorStyles,
                iconTheme: undefined,
                icon: null,
            });
        }
        else {
            toast.error(typeof error === "object" && error !== null && "message" in error
                ? `There was an error, please refresh and try again.`
                : error || errorMessage, {
                duration: duration.error,
                position,
                style: errorStyles,
                iconTheme: errorIconTheme,
            });
        }
    };
    const handleWithToast = (asyncFn) => {
        return async (...args) => {
            try {
                const result = await asyncFn(...args);
                showSuccessToast();
                return result;
            }
            catch (error) {
                showErrorToast(error);
                throw error;
            }
        };
    };
    return {
        handleWithToast,
        showSuccessToast,
        showErrorToast,
    };
};
//# sourceMappingURL=useToastWrapper.js.map